import { useEffect, useState } from "react";
import { CERT_LIST, axiosCert } from "../axios";
import { parseCerts } from "./certParser";
import useAuth from "../../utils/CustomHooks/useAuth/useAuth";
/**
 * Hook that return null if loading, or array of certs
 * @returns {null | {subjKeyId : string, subject : string}[]}
 */

export function useGetCerts() {
  const axios = axiosCert;
  const [certs, setCerts] = useState(null);
  useEffect(() => {
    axios
      .get(CERT_LIST)
      .then(({ data }) => parseCerts(data))
      .then((res) => setCerts(res))
      .catch((error) => console.log(error));
  }, [axios]);
  return certs;
}

/**
 * Hook that returns cert that is being used. Subject is undefined if machine does not have certificate
 * @returns {{isLoading : boolean, subject : string | undefined, subjKeyId : string}}
 */

export function useGetMyCert() {
  const certs = useGetCerts();
  const {
    auth: {
      user: { cert: certId },
    },
  } = useAuth();
  return {
    subject: certs?.find((certEl) => certEl.subjKeyId === certId)?.subject,
    subjKeyId: certId,
    isLoading: certs === null,
  };
}
